import { inject, Injectable } from '@angular/core';
import { SessionTimesEndpoints } from 'app/core/enums/endpoints/session-times.enum';

import { ApiService } from 'app/services/api/api.service';
import { UtilsService } from 'app/services/utils.service';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class SessionTimesService {
    private _endpoint = SessionTimesEndpoints;
    private utils = inject(UtilsService);
    private _apiService = inject(ApiService);

    private apiUrl = environment.apiUrl;

    constructor() {}

    // ----------------------------------------------------------------------
    // @ Public methods
    // ----------------------------------------------------------------------
    // ----------------------------------------------------------------------
    // @ CRUD methods
    // ----------------------------------------------------------------------

    /**
     * @description
     * Get all session times
     * @returns
     */
    getAll(): Observable<any> {
        return this._apiService.get(this._endpoint.getAll);
    }

    /**
     * @description
     * Get single session time
     * @returns
     */
    getOne(id: number): Observable<any> {
        return this._apiService.getOne(this._endpoint.getOne, id);
    }

    /**
     * @description
     * Create a new session time
     * @returns
     */
    create(
        sessionTimeData: { hour: string },
        playdateId: number
    ): Observable<any> {
        return this._apiService.post(
            `${this._endpoint.create}/${playdateId}`,
            sessionTimeData
        );
    }

    /**
     * @description
     * Update a session time
     * @returns
     */
    update(sessionTimeData: string, id: number): Observable<any> {
        return this._apiService.update(
            this._endpoint.patch,
            sessionTimeData,
            id
        );
    }

    /**
     * @description
     * Delete a session time
     * @returns
     */
    delete(id: number): Observable<any> {
        return this._apiService.delete(this._endpoint.delete, id);
    }
}
